const checkAnsweredData = (answer, answers) => {
  if (answers && answers.indexOf(answer.id) !== -1) {
    answer.answered = true
    // if the answered answer equals 0.. then add +1 to avoid confusion (cache)
    if (answer.result === 0) {
      answer.result = 1
    }
  }

  return answer
}

export const totalAndCheckForAnsweredData = (chartData, answers) => {
  // Compute the rank of the answers (most popular)
  let index = 1
  const sortedData = [...chartData.answersData].sort((a, b) => {
    if (a.result > b.result) {
      return -1
    } else if (a.result < b.result) {
      return 1
    }
    return 0
  }).map(x => ({ ...x, index: index++ }))

  let totalVotes = 0
  for (let i = 0; i < chartData.answersData.length; i++) {
    chartData.answersData[i].show = false
    chartData.answersData[i] = checkAnsweredData(chartData.answersData[i], answers)
    chartData.answersData[i].index = sortedData.find(x => x.id === chartData.answersData[i].id).index
    totalVotes += chartData.answersData[i].result
  }

  chartData.total = chartData.participations
  chartData.totalVotes = totalVotes
  chartData.sortedData = sortedData
  return chartData
}

const checkAnsweredSwiper = (answer, answers) => {
  if (answers[answer.id] != null) {
    answer.answered = answers[answer.id] ? 'right' : 'left'
  }
  return answer
}

export const totalAndCheckForAnsweredDataSwiper = (chartData, answers) => {
  try {
    answers = JSON.parse(answers)
  } catch (e) {
    answers = {}
  }
  // Compute the rank of each answer (most right swipe)
  let index = 1
  const sortedData = [...chartData.answersData].sort((a, b) => {
    if (a.result.right > b.result.right) {
      return -1
    } else if (a.result.right < b.result.right) {
      return 1
    }
    return 0
  }).map(x => ({ ...x, index: index++ }))

  for (let i = 0; i < chartData.answersData.length; i++) {
    chartData.answersData[i] = checkAnsweredSwiper(chartData.answersData[i], answers)
    chartData.answersData[i].index = sortedData.find(x => x.id === chartData.answersData[i].id).index
  }

  chartData.total = chartData.participations
  return chartData
}

export const totalAndCheckForMatrix = (chartData) => {
  for (let i = 0; i < chartData.answersData.length; i++) {
    let totalSub = 0
    for (let ii = 0; ii < chartData.answersData[i].subQuestionAnswers.length; ii++) {
      totalSub += chartData.answersData[i].subQuestionAnswers[ii].result
    }
    chartData.answersData[i].subQuestionAnswers.total = totalSub
  }

  chartData.total = chartData.participations
  return chartData
}



// WEBPACK FOOTER //
// ./src/helpers/total.js